import { Col, Space } from 'antd'
import { FC } from 'react'

import { BitazzaText } from '../../../../components'
import { format } from '../../../../components/common/Typography/Text'

interface Props {
    img: string
    total: string | number
    product: string
    reward?: string
    textFormat?: format
    textColor?: string
    bigImg?: boolean
}
export const Reward: FC<Props> = ({
    img,
    total,
    product,
    reward,
    textFormat,
    textColor,
    bigImg,
}) => {
    return (
        <Col span={12}>
            <Space direction="vertical" size={0}>
                <img
                    src={img}
                    alt="rewards"
                    width={bigImg ? 64 : 48}
                    style={{ paddingBottom: '8px' }}
                />
                <BitazzaText
                    content={total}
                    color={textColor ? textColor : '#10F48B'}
                    format={textFormat ? textFormat : 't20'}
                    lineHeight={26}
                    strong
                />
                <BitazzaText
                    content={product}
                    color="#FFFF"
                    letterSpacing={bigImg ? 2 : 1}
                />
                {bigImg ? null : (
                    <BitazzaText content={reward || ''} color="#86A1A1" />
                )}
            </Space>
        </Col>
    )
}
